<template>
  <div class="code-multiple">
    <el-select class="code-multiple-more"
               :class="{ 'code-multiple-more-tag': collapseTags, 'code-multiple-more-disabled': disabled }"
               :popper-class="popperClass ? 'zwx-select-popper ' + popperClass : 'zwx-select-popper'" :ref="refVariable"
               v-model="codeValueList" placeholder="请选择" :clearable="clearable" :disabled="disabled" multiple
               :collapse-tags="collapseTags">
      <el-option v-for="item in simpleCodeList" :key="item.codeNo" :label="item.codeName"
                 :value="item.codeNo"/>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'CodeMultiple',
  model: {
    prop: 'simpleCodeValueList',
    event: 'propEvent',
  },
  props: {
    codeType: {type: String},
    simpleCodeValueList: {type: Array, default: () => []},
    collapseTags: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    popperClass: {type: String},
    serviceName: {type: String, default: 'systematic'},
    apiSign: {type: Boolean, default: true},
    apiWhite: {type: Boolean, default: false},
  },
  data() {
    return {
      api: this.$store.state.api,
      refVariable: 'codeMultiple' + this.$system.uuid(),
      simpleCodeList: [],
      codeValueList: this.simpleCodeValueList,
    }
  },
  watch: {
    simpleCodeValueList(newValue) {
      this.codeValueList = newValue
    },
    codeValueList(newValue) {
      this.setElTagsWidth()
      this.$emit('propEvent', newValue)
    },
  },
  mounted() {
    this.search()
    this.setElTagsWidth()
  },
  methods: {
    setElTagsWidth() {
      if (!this.collapseTags) return
      this.$nextTick(() => {
        if (this.codeValueList && this.codeValueList.length > 1) {
          this.$refs[this.refVariable].$children[2].$el.style.maxWidth = `calc(100% - ${this.$refs[this.refVariable].$children[3].$el.offsetWidth}px)`
        } else {
          if (!this.$refs[this.refVariable].$children[2]) return
          this.$refs[this.refVariable].$children[2].$el.style.maxWidth = '100%'
        }
      })
    },
    search() {
      let data = {
        codeTypeCode: this.codeType,
      }
      this.$system.get(this.api + '/' + this.serviceName + '/getSimpleCodeListByCodeTypeCode-' + (this.apiWhite ? '0' : '1'), data, !this.apiWhite, this.apiSign, this.searchSuccess, this.searchError)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.simpleCodeList = data.simpleCodeList
      }
      this.$emit('loadOver')
    },
    searchError() {
      this.$emit('loadOver')
    },
    getSimpleCodeList() {
      if (!this.codeValueList || this.codeValueList.length === 0) return []
      const simpleCodeSelectList = []
      for (let i = 0, length = this.simpleCodeList.length; i < length; i++) {
        for (let k = 0, len = this.codeValueList.length; k < len; k++) {
          if (this.simpleCodeList[i].codeNo === this.codeValueList[k]) {
            simpleCodeSelectList.push(this.simpleCodeList[i])
          }
        }
      }
      return simpleCodeSelectList
    },
  },
}
</script>

<style lang="less" scoped>
.code-multiple {
  display: inline-block !important;
}

.code-multiple .code-multiple-more {
  cursor: pointer !important;
}

.code-multiple .code-multiple-more-disabled {
  cursor: not-allowed !important;
}

.code-multiple /deep/ .code-multiple-more .el-input__inner {
  width: 160px !important;
  height: auto;
  line-height: 28px !important;
  min-height: 28px !important;
  padding: 0 19px 0 6px !important;
  box-sizing: border-box !important;
  border: 1px solid #a8bbcf !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #000 !important;
  border-radius: 2px !important;
}

.code-multiple /deep/ .code-multiple-more .el-input__inner:hover {
  border: 1px solid #8094a7 !important;
}

.code-multiple /deep/ .code-multiple-more .el-input.is-focus .el-input__inner {
  border-color: #457dff !important;
}

.code-multiple /deep/ .code-multiple-more .el-input__inner:focus {
  border: 1px solid #457dff !important;
}

.code-multiple /deep/ .code-multiple-more .is-disabled .el-input__inner {
  background-color: #eff2f9 !important;
  color: #646464 !important;
}

.code-multiple /deep/ .code-multiple-more .is-disabled .el-input__inner:hover {
  border: 1px solid #a8bbcf !important;
}

.code-multiple /deep/ .code-multiple-more .el-input__suffix {
  right: 0 !important;
}

.code-multiple /deep/ .code-multiple-more .el-input__icon {
  width: 22px !important;
  font-size: 8px !important;
  line-height: 28px !important;
  color: #6d87a3 !important;
}

.code-multiple /deep/ .code-multiple-more .el-icon-circle-close:hover {
  color: #37608c !important;
}

.code-multiple /deep/ .code-multiple-more-tag .el-select__tags {
  flex-wrap: nowrap !important;
}

.code-multiple /deep/ .code-multiple-more .el-tag .el-select__tags-text {
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
}

.code-multiple /deep/ .code-multiple-more .el-tag.el-tag--info.el-tag--small {
  display: flex !important;
  align-items: center !important;
  max-width: 100%;
  height: 18px !important;
  line-height: 16px !important;
  padding: 0 4px !important;
  color: #3a485e !important;
  background: rgba(168, 187, 207, 0.26) !important;
  border-radius: 2px !important;
}

.code-multiple /deep/ .code-multiple-more .el-tag__close.el-icon-close {
  right: -3px !important;
  margin-top: 0 !important;
}

.code-multiple /deep/ .code-multiple-more .el-tag__close.el-icon-close::before {
  width: 16px !important;
  height: 16px !important;
}

.code-multiple /deep/ .code-multiple-more input::input-placeholder {
  color: #aaaaaa !important;
}

.code-multiple /deep/ .code-multiple-more input::-webkit-input-placeholder {
  color: #aaaaaa !important;
}

.code-multiple /deep/ .code-multiple-more input:-moz-placeholder {
  color: #aaaaaa !important;
}

.code-multiple /deep/ .code-multiple-more input::-moz-placeholder {
  color: #aaaaaa !important;
}

.code-multiple /deep/ .code-multiple-more input:-ms-input-placeholder {
  color: #aaaaaa !important;
}
</style>

<style lang="less"></style>
